import { useDataSourceColumns } from "@/hooks";
import type { ColumnTypeTransformer } from "@/types/workspace";
import { Flex, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { TransformerBase } from "./TransformerBase";

export function TransformerColumnType({
  data,
  warning,
  error,
  onUpdate,
  index,
}: {
  data: ColumnTypeTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: ColumnTypeTransformer) => void;
  index: number;
}) {
  const [column, setColumn] = useState(data.item_list[0]?.column || "");
  const [newType, setNewType] = useState(data.item_list[0]?.new_type || "");
  const availableColumns = useDataSourceColumns(index);

  useEffect(() => {
    setColumn(data.item_list[0]?.column || "");
    setNewType(data.item_list[0]?.new_type || "");
  }, [data.item_list]);

  const handleColumnChange = (value: string | null) => {
    if (value !== null) {
      setColumn(value);
      if (onUpdate) {
        onUpdate({
          ...data,
          item_list: [{ column: value, new_type: newType }],
        });
      }
    }
  };

  const handleTypeChange = (value: string | null) => {
    if (value !== null) {
      setNewType(value);
      if (onUpdate) {
        onUpdate({
          ...data,
          item_list: [{ column, new_type: value }],
        });
      }
    }
  };

  return (
    <TransformerBase warning={warning} error={error}>
      <Flex direction="row" gap={8}>
        <Select
          variant="light"
          bdrs="sm"
          bg="#F1F3F4"
          placeholder="Column"
          data={availableColumns.length > 0 ? availableColumns : []}
          value={column}
          onChange={handleColumnChange}
        />
        <Select
          variant="light"
          bdrs="sm"
          bg="#F1F3F4"
          placeholder="Type"
          data={["string", "int", "float", "bool", "datetime"]}
          value={newType}
          onChange={handleTypeChange}
        />
      </Flex>
    </TransformerBase>
  );
}
